import http from "./HttpCommon"; 

class LabServices {
  getLabReportDetails(data) {
    const queryString = Object.keys(data)
      .map((key) => key + "=" + data[key])
      .join("&");
    return http.get(`LabTestsOrderReport/list/filter?${queryString}`);
  }
}

export default new LabServices();